import React, { Suspense, useEffect, useState } from "react";
import { connect } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import styled, { createGlobalStyle, ThemeProvider, keyframes } from "styled-components";
import Header from "../Header/Header";
import Loading from "../Loading/Content.Loading";
import { useWindowSize } from "../Conversation/Utility/hooks";
import Footer from "../Footer/Footer";

// Show suspense while this
const Conversation = React.lazy(() => import("../Conversation/Conversation"));

// Global style from styled components that is applied everywhere
const GlobalStyle = createGlobalStyle`
  body {
    background-color: ${(props) =>
      props.data.themeColors[props.data.activeTheme].windowBackgroundColor};

    transition: all ${(props) =>
      props.data.themeColors[props.data.activeTheme]
        .transitionSpeed} ease-in-out;

    @media screen and (min-width: ${(props) =>
      props.data.screenSizes.breakLaptop}) {
        background: ${(props) =>
          props.data.themeColors[props.data.activeTheme]
            .windowBackgroundImage != null
            ? "url('" +
              props.data.themeColors[props.data.activeTheme]
                .windowBackgroundImage +
              "')"
            : props.data.themeColors[props.data.activeTheme]
                .windowBackgroundColor};
    }

    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }

  *:not(.UnitList):not(.ListFloorplansWraper):not(.rows-wrapper)::-webkit-scrollbar { display: none; }

  * {
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
  }

  ${(props) => {
    if (props.data.new_branding && props.data.new_branding === "1") {
      return `.Bubble { 
        background:#F5F5F6 !important;
        color: #2F2C3E !important;
       }
       
       .bubble {
       background: #3B374E !important;
         }
       
       .QuickLinkText {
         border: 2px solid #2F2C3E !important;
       }
       
       .QuickLinkText:hover {
          background: #3B374E !important;
       }
       
       
       .ImageButton > div:last-child {
          color: #4F4B60 !important;
       }
       
         .ImageButton:hover > div:last-child {
          color: #4B8D71 !important;
       }
       
       .active-date > .day {
       color: #4B8D71 !important;
       }
       
       .StyledCarouselItem > div:hover > .day {
         color: #4B8D71 !important;
         
         }
         
         .StyledCarouselItem > div > .month {
           color: #4F4B60 !important;
         }
         
         .StyledCarouselItem > div > .weekday {
           color: #4F4B60 !important;
         }
         
         .time-container:hover > .hour {
            color: #4B8D71 !important;
         }
         
         .period {
          color: #4F4B60 !important;
         }
         
      .date-flag {
           border-radius: 50px !important;
           background:  #EDF4F1 !important;  
          color: #3C715A !important;
          padding: 4px 6px !important;
     
         }
         
         .FloorplanContainer > div:last-of-type {
            background: #4B8D71 !important;
         }

          .FloorplanContainer > div:last-of-type:hover {
            background: #3C715A !important;
         }
         
         
         .floorploan-banner {
         color: #3B374E !important;
         }
         
         
         .FloorplanImageWrapper .date {
            color: #4F4B60 !important;
         }
         
         .FloorplanImageWrapper .available {
            background: #4B8D71 !important;
         }
         
         
         .FloorplanImageWrapper .title {
           color: #3B374E !important;
         }
         
          .FloorplanImageWrapper .price-wrapper {
            color: #4F4B60 !important;
         }
         
          .FloorplanImageWrapper .price {
            color: #3B374E !important;
         }
         
         .info-number {
         
         border-bottom: 2px solid #4B8D71 !important;
         }
         
         .open-floorplan {
          background-color: #4B8D71 !important;
         }
         
         .BedroomDescription {
            color: #3B374E !important;
         }
         
         .info-description {
           color: #767383 !important;
         }
         
         .floorplan-image-wrapper {
            background: #EAF1F5 !important;
         }
         
         .floorplan-image-wrapper.floorplan-image-wrapper-embedded {
            background: #EAF1F5 !important;
         }
         
         .floorPlanName {
           color: #3B374E !important;
         }
         
         .info-description {
           color: #898795 !important;
         }
         
             .tab-name {
           color: #4B8D71 !important;
         }
         
         .tab-container .active-tab {
          border-bottom: 3px solid  #4B8D71 !important; 
         }
         
         .leftInfo .info-date {
           color: #625F71 !important;
         }
         
         .leftInfo .unit-name {
            color: #3B374E !important;
         }
         
         .leftInfo .floor {
            color: #898795 !important;
         }
         
         .rightInfo .unit-price {
            color: #3B374E !important;
         }
         
         .rightInfo .month {
            color: #898795 !important;
         }
         
         .showMore {
           background: #EDF4F1 !important;

         }

         .showMore:hover {
          background: #DBE8E3 !important;
         }
         
         .show-more-btn {
         color: #4B8D71 !important;
         }
         
         .apply-now {
           border: 1px solid  #4B8D71 !important;
          background: #F6F9F8 !important;
         }

         .apply-now:hover {
          background: #DBE8E3 !important;
         }
         
         .show-content-title {
           color: #9D9BA6 !important;
           opacity: 1 !important;
         }
         
         .show-content-content {
           color: #4F4B60 !important;
         }
         
          .unitList .notify-button .TextAppearFromBottom .QuickLinkText  {
          background-color: #4B8D71 !important;
          border: none !important;
         }
         
             .unitList .notify-button .notify-button-redirect  {
              background: #4B8D71 !important;
         }

         .resident-contact-title {
             color: #3B374E !important;
         }

         .resident-contact-availability {
           color: #4B8D71 !important;
         }

         .resident-contact-details {
           color: #4F4B60 !important;
         }

         .contact-group {
          color: #4F4B60 !important;
         }

         .contact-info {
          color: #4F4B60 !important;
         }

         .BackQuickLinkText {
          background: #EBEBED !important;
         }

         .BackQuickLinkText:hover {
          background: #3B374E !important;
         }

         .WithInput button {
          background: #3B374E !important;
         }

         .WithInput .StyledTextarea {
           border: 2px solid #3B374E !important;
         }

         .SpecialsWrapper .next {
           background: #4B8D71 !important;
         };  

         .InputWrapper button {
           background: #3B374E !important;
         }

         .FooterContainer a {
            color: #4F4B60 !important;
         }

         .CustomOrAnyQuickLinkText:hover {
           background: #3B374E !important;
         }

         .MultibotText img {
           border: 4px solid green !important;
         }

         .MultibotText:hover {
          background: #3B374E !important;
         }

                 @keyframes typingAnimationBefore {
                 0% { box-shadow: 9984px 0 0 -5px #B7D1C6;}
                 30% { box-shadow: 9984px 0 0 2px #B7D1C6; }
                 60%, 100% { box-shadow: 9984px 0 0 -5px #B7D1C6; }
                }

                

            @keyframes typingAnimationAfter {
              0% { box-shadow: 10014px 0 0 -5px #B7D1C6; }
              30% { box-shadow: 10014px 0 0 2px #B7D1C6; }
              60%, 100% { box-shadow: 10014px 0 0 -5px #B7D1C6; }
             }
          
        .TypingWrapper > div:before { 
           animation: typingAnimationBefore 1.5s infinite;
           animation-delay: 0s;
           margin-left: -30px;
         }

         .TypingWrapper > div:after { 
            animation: typingAnimationAfter 1.5s infinite;
            animation-delay: 0.5s;
           margin-left: -5px;
         }

         .TypingWrapper > div {
          animation: typingAnimationBefore 1.5s infinite;
          animation-delay: 0.25s;
          
         }

        .apply-now-btn {
            background: #F6F9F8 !important;
            border: 1px solid #4B8D71 !important;
        }
        
        .apply-now-btn:hover {
          background: #DBE8E3 !important;
        }



         
         
         `;
    }
  }};
  

`;


/**
 * Complete App Wrapper
 * holds props that append custom css written in "your brand -> bot window" section
 *  */
const AppWrapper = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
  position: relative;
  height: 100%;
  width: 100%;
  ${(props) =>
    props.theme.themeColors[props.theme.activeTheme].window_custom_css || ""};

  @media screen and (min-height: 100px) and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakLaptop}) {
    padding-top: 48px;
  }

  @media screen and (min-height: 500px) and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakLaptop}) {
    padding-top: 40px;
  }

  @media screen and (min-height: 900px) and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakLaptop}) {
    padding-top: 96px;
  }
`;

const ContentWrapper = styled.div`
  background: ${(props) =>
    props.theme.themeColors[props.theme.activeTheme].contentBackgroundColor};

  @media screen and (max-width: ${(prop) =>
      prop.theme.screenSizes.breakLaptop}) {
    display: flex;
    justify-content: center;
    position: relative;
    height: 100%;
    width: 100%;
  }

  @media screen and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakLaptop}) {
    box-shadow: 1px 1px 31px 0 rgba(0, 0, 0, 0.15);
    -webkit-box-shadow: 1px 1px 31px 0 rgba(0, 0, 0, 0.15);
    -moz-box-shadow: 1px 1px 31px 0 rgba(0, 0, 0, 0.15);
    width: 1300px;
    border-radius: 20px;
    position: relative;
    max-height: ${({ maxHeight }) => maxHeight}px;
    overflow: hidden;
  }
`;

const Content = styled.div`
  @media screen and (max-width: ${(prop) =>
      prop.theme.screenSizes.breakLaptop}) {
    display: flex;
    justify-content: center;
    position: relative;
    height: 100%;
    width: 100%;
  }

  @media screen and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakLaptop}) {
    overflow-y: scroll;
    height: 100%;
  }
  position: relative;
`;

function App({
  screenSizes,
  themeColors,
  activeTheme,
  inIframe,
  property,
  new_branding,
}) {
  const { width, height } = useWindowSize();
  const [maxHeight, setMaxHeight] = useState(0);

  useEffect(() => {
    if (width > 1000) {
      if (height >= 900) {
        setMaxHeight(height - 200);
      } else if (height >= 500 && height < 900) {
        setMaxHeight(height - 85);
      } else if (height < 500) {
        setMaxHeight(height - 96);
      }
    }
  }, [height, width]);

  if (
    property &&
    property.property_skip_betterbot_indexing == "1" &&
    document.querySelectorAll('meta[name="robots"][content="noindex"]')
      .length == 0
  ) {
    const meta = document.createElement("meta");
    meta.setAttribute("name", "robots");
    meta.setAttribute("content", "noindex");

    document.getElementsByTagName("head")[0].appendChild(meta);
  }

  return (
    <Router>
      <GlobalStyle
        data={{ themeColors, activeTheme, screenSizes, new_branding }}
      />
      {/* Theme Provider adds the ability to access given parameters in child styled components */}
      <ThemeProvider
        theme={{ screenSizes, themeColors, activeTheme, inIframe }}
      >
        <AppWrapper className="AppWrapper">
          <ContentWrapper className="ContentWrapper" maxHeight={maxHeight}>
            <Content className="Content">
              <Header />
              {/* Suspense renders given "fallback" until child components render */}
              <Suspense fallback={<Loading />}>
                <Switch>
                  {/* Call this route when you want to directly start a different intent e.g. url.com/ScheduleTour */}
                  <Route exact path="/:intent?" component={Conversation} />
                  <Route path="*">
                    <div>Error 404 URL not found.</div>
                  </Route>
                </Switch>
              </Suspense>
              <Footer />
            </Content>
          </ContentWrapper>
        </AppWrapper>
      </ThemeProvider>
    </Router>
  );
}

const mapStateToProps = (state) => ({
  screenSizes: state.settings.screenSizes,
  inIframe: state.settings.inIframe,
  themeColors: state.settings.themeColors,
  activeTheme: state.settings.activeTheme,
  property: state.property,
  new_branding: state.settings.new_branding,
});

const ConnectedPage = connect(mapStateToProps)(App);

export default ConnectedPage;
